<template>
  <div class="detailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="chant">
      <div class="bussy">
        <h2>{{detail.title}}</h2>
        <div class="star"><img src="~assets/images/starO.png" />{{detail.star}}
          <span>月售{{detail.sale}}</span>
          <font>商家配送</font>
          <font>全场5.5折起</font>
        </div>
      </div>
      <div class="logo">
        <el-image style="width:100%;height:60px; border-radius:5px;" :src="baseUrl+detail.logo" fit="cover"></el-image>
      </div>
      <div class="coupon" @click="receive(item.id,item.price)" v-for="(item,i) in coupon" v-if="item.total<item.num">
        <span><font>商劵</font>{{item.title}}<i>{{parseInt(item.price)}}</i>元</span>
        <span class="last">领取</span>
      </div>

    </div>

    <div class="tab">
      <a @click="chooseTab(1)" :class="active == 1 ? 'curt':''">热销</a>
      <a @click="chooseTab(2)" :class="active == 2 ? 'curt':''">评价</a>
      <a @click="chooseTab(3)" :class="active == 3 ? 'curt':''">商家</a>
      <a @click="chooseTab(4)" :class="active == 4 ? 'curt':''">会员</a>

      <!--<el-switch
        v-model="value" :width="60"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-value="2"
        inactive-value="1" active-text="外卖" inactive-text="到店">
      </el-switch>-->
      <div class="logistics">
        <p @click="value = 1" :class="value == 1 ? 'on' : ''"><i :class="value == 1 ? 'el-icon-success' : 'el-icon-circle-check'"></i>到店</p>
        <p @click="value = 2" :class="value == 2 ? 'on' : ''"><i :class="value == 2 ? 'el-icon-success' : 'el-icon-circle-check'"></i>外卖</p>
      </div>
    </div>

    <div class="goods" v-if="active == 1" :style="'height:'+(curHeight-135)+'px'">
      <ul>
        <li :class="cate_id == 0 ? 'curt' : ''" @click="djcate(0)">全部</li>
        <li :class="cate_id == item.id ? 'curt' : ''" v-for="(item,i) in procate" @click="djcate(item.id)">{{item.title}}</li>
        <li style="height:50px"></li>
      </ul>
      <dl class="proList">
        <dd v-for="(item,i) in pro" @click="$router.push('choosepro?id='+item.id)">
          <div class="fmt">
            <el-image style="width:100%;height:80px; border-radius:5px;" :src="baseUrl+item.img" fit="cover"></el-image>
          </div>
          <div class="right">
            <h2>{{item.title}}</h2>
            <div class="sales">销量：{{item.num}}单</div>
            <div class="price">
              <span>￥{{item.rate}}</span>
              <font>￥{{item.price}}</font>
            </div>
            <div class="cart">
              <span>＋
              <font v-if="item.sl > 0">{{item.sl}}</font></span>
            </div>
          </div>
        </dd>
        <dd style="height:50px"></dd>
      </dl>

      <!--<div class="footPro">
        <div class="price" @click="fintCart">
          <p>￥{{setUserSvip != null ? (setUserSvip.type == 0 ? '0.00' : price) : price}}</p>
          <p>已选中{{total}}件商品</p>
        </div>
        <div class="settle" v-if="total <= 0" style="background:#ebebeb">请选择商品</div>
        <div class="settle" @click="settle" v-if="total > 0">去结算</div>
      </div>-->
      <div class="footPro">
        <div class="left">
          <a @click="$router.push('index')"><em class="el-icon-s-home"></em>首页</a>
          <a @click="$router.push('porder')"><em class="el-icon-document"></em>订单</a>
          <a @click="fintCart"><em class="el-icon-shopping-cart-1"></em>购物车<font v-if="total > 0">{{total}}</font></a>
        </div>
        <div class="right" v-if="total > 0" @click="settle">
          <span><em>￥</em>{{setUserSvip != null ? (setUserSvip.type == 0 ? '0.00' : price.toFixed(1) + detail.take_price) : price + (value == 2 ? (detail.take_price*1) : 0)}}<em> / {{total}}件 {{value == 2 ? '含配送费' :''}}</em></span>
          <font>立即购买</font>
        </div>
        <div class="right" style="background:rgba(243, 109, 120, 0.6);" v-if="total <= 0">
          <span style="padding-top:1px">不可结算</span>
          <font>请选择商品</font>
        </div>
      </div>
    </div>

    <div class="comment" v-if="active == 2" :style="'height:'+(curHeight-135)+'px'">
      <div style="height:60px"></div>
      <img src="~assets/images/no.png">
    </div>

    <div class="chants" v-if="active == 3">
      <div style="height:5px"></div>
      <ul>
        <li @click="uls">
          <span>{{detail.address}}</span>
          <a style="float:right;color:#666">导航去<em class="el-icon-arrow-right"></em></a>
        </li>
        <li v-if="detail.img != null">
          <img v-for="(item,i) in detail.img" class="sjImg" :src="baseUrl+item">
        </li>
        <li>
          <span>配送服务：商家提供高品质配送服务</span>
        </li>
        <li>
          <span>营业时间：{{detail.business}}</span>
        </li>
        <li>
          <span>商家简介：{{detail.content}}</span>
        </li>
        <li>
          <span>商家联系方式：<a :href="'tel:'+detail.phone">{{detail.phone}}</a></span>
        </li>
      </ul>
    </div>

    <div v-if="active == 4" class="svipDetail" :style="'height:'+(curHeight-135)+'px'">
      <div style="height:15px;"></div>

      <div class="vipUser">
        <img class="avatar" :src="userData.avatar"/>
        <p>
          <span>{{userData.username}}<img v-if="setUserSvip != null" src="~assets/images/vipimg.png"/></span>
          <font>有效期：{{setUserSvip != null ? setUserSvip.starttime+' 至 '+setUserSvip.endtime : '暂未开通'}}</font>
          <font style="color:#FF751A;">svip类型：{{setUserSvip == null ? '无' : setUserSvip.type == 1 ? 'Svip会员' :'内部员工'}}</font>
        </p>
        <a @click="yqmKai">内部邀请</a>
      </div>

      <h2 v-if="setSvip.length > 0">SVIP列表
        <span class="gmjl" @click="$router.push('viporder')">购买记录<img src="~assets/images/icon5.png"/></span>
      </h2>
      <ul>
        <li @click="chooseVip(i,item.type,item.id,item.rate)" :class="i == xzSvip ? 'active' : ''" v-for="(item,i) in setSvip">
          <div class="title">{{item.title}}</div>
          <div class="desc">
            <p class="yh">{{parseInt((item.rate/item.price)*10)}}折优惠</p>
            <p class="money"><i>¥</i><span>{{item.rate}}</span></p>
            <p class="old">原价¥{{item.price}}</p>
          </div>
        </li>
        <div class="pick"></div>
      </ul>
      <div style="height:40px"></div>
      <button v-if="setSvip.length > 0" @click="paySvip" class="kaitong">立即开通</button>
    </div>

    <el-dialog title="内部员工会员开通" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="邀请码">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="openSvip">确 定</el-button>
      </div>
    </el-dialog>

    <el-drawer title="" :visible.sync="drawer" size="50%" :direction="direction" :withHeader="false" :show-close="false">
      <div class="cartHead">
        <div class="cleft">已选商品{{total}}件</div>
        <div class="cright" @click="clearCart"><em class="el-icon-delete"></em> 清空购物车</div>
      </div>
      <div class="goods">
        <dl class="proList" style="width:92%;margin:0 auto;position:static ">
          <dd v-for="(item,i) in cart" @click="$router.push('choosepro?id='+item.id)">
            <div class="fmt">
              <el-image style="width:100%;height:80px; border-radius:5px;" :src="baseUrl+item.img" fit="cover"></el-image>
            </div>
            <div class="right">
              <h2>{{item.title}}</h2>
              <div class="sales">{{item.attr == '' ? '选购：' : item.attr+'；'}}{{item.num}}件</div>
              <div class="price">
                <span>￥{{item.rate}}</span>
                <font>￥{{item.price}}</font>
              </div>
            </div>
          </dd>
          <dd style="height:50px"></dd>
        </dl>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        drawer:false,
        direction: 'btt',
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        detail:[],
        coupon:[],
        procate:[],
        pro:[],
        active:1,
        cate_id:0,
        total:0,
        price:'0.00',
        value:1,
        dialogFormVisible: false,
        form: {
          name: ''
        },
        setSvip:[],
        xzSvip:0,
        setUserSvip:[],
        vip_id:0,
        classes:0,
        code:'',
        vipPrice:0,
        cart:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var b_id = this.$route.query.id;
        var number = this.$route.query.number;
        number = number == undefined ? 0 : number;
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/detail?id='+b_id+'&number='+number);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    created(){
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getCate();
      this.getPro();
      this.userSvip();

      
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      chooseTab:function(i){
        this.active = i;
        if(i == 4){
          this.svip();
        }
      },
      getDetail:function(){
        var that = this;
        var b_id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/detail',
          params:{
            b_id:b_id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.detail = res.rs;
          that.coupon = res.coupon;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      uls:function(){
        let tengxunH5Url = 'https://apis.map.qq.com/uri/v1/marker?marker=coord:'+this.detail.latitude+','+this.detail.longitude+';title:'+this.detail.title+';addr:'+this.detail.address+'&referer=aSPSDxIofuEALG56BcTsXkOHv7g8Pusb';
        window.setTimeout(() => {
          window.location.href = tengxunH5Url;
        }, 10);
      },
      receive:function(id,price){
        var that = this;
        var cate_id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/product/userReceive',
          params:{
            cate_id:cate_id,
            c_id:id,
            user_id:that.userData.id,
            price:price
          }
        }).then(function(response){
          var res = response.data;
          that.getDetail();
          if(res.status == 200){
            that.$alert('您已成功领取一张优惠劵', '提示', {
              confirmButtonText: '确定'
            });
          }else{
            that.$alert(res.message, '提示', {
              confirmButtonText: '确定'
            });
          }
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      getCate:function(){
        var that = this;
        var b_id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/product/proCate',
          params:{
            b_id:b_id
          }
        }).then(function(response){
          var res = response.data.data;
          that.procate = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      djcate:function(id){
        this.cate_id = id;
        this.getPro();
      },
      getPro:function(){
        var that = this;
        var b_id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/product/product',
          params:{
            b_id:b_id,
            page:1,
            cate_id:that.cate_id
          }
        }).then(function(response){
          var res = response.data.data;
          var arr = JSON.parse(localStorage.getItem('ucart'+b_id));

          var price = 0;
          var total = 0;
          var arrtPrice = 0;
          if(arr != null){ 
            for(var i=0;i<arr.length;i++){
              arrtPrice += arr[i].total;
            }

            var result = that.keyPlusValue(arr);
            var ret = [];
            for(var i=0;i<result.length;i++){
              ret[result[i].id] = result[i].num
            }console.log(ret)
            for(var i=0;i<res.length;i++){
              if(ret[res[i].id] > 0){
                res[i].sl = ret[res[i].id];
                price = price + (ret[res[i].id] * res[i].rate);
                total = total + ret[res[i].id];
              }
            }
          }
          that.price = price + arrtPrice;
          that.total = total;
          that.pro = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      keyPlusValue:function (arr) {
        const result = arr.reduce((obj, item) => {
          if (!obj[item.id]) {
            obj[item.id] = 0
          }
          obj[item.id] += item.num
          return obj
        }, {})
        return Object.keys(result).map(key => ({id: key, num: result[key]}))
      },
      jia: function (e) {
        var that = this;
        var id = e.currentTarget.dataset.id;
        var index = e.currentTarget.dataset.index;
        var postList = that.pro;
        var num = postList[index].sl;
        
        num++;
        postList[index].sl = num;
        var total = parseInt(that.total) + 1;
        var price = parseFloat(that.price) + parseFloat(postList[index].rate);
        that.pro = postList;
        that.total = total;
        that.price = price.toFixed(2);
      },
      jian: function (e) {
        var that = this;
        var id = e.currentTarget.dataset.id;
        var index = e.currentTarget.dataset.index;
        var postList = that.pro;
        var num = postList[index].sl;
        
        num--;
        postList[index].sl = num;
        var total = parseInt(that.total) - 1;
        var price = parseFloat(that.price) - parseFloat(postList[index].rate);
        that.pro = postList;
        that.total = total;    
        that.price = price.toFixed(2);   
      },
      fintCart:function(){
        if(this.total <= 0){
          return false;
        }
        var b_id = this.$route.query.id;
        if(localStorage.getItem('ucart'+b_id) != null){
          this.cart = JSON.parse(localStorage.getItem('ucart'+b_id))
        }
        this.drawer = true;
      },
      clearCart:function(){
        var b_id = this.$route.query.id;
        localStorage.removeItem('ucart'+b_id);
        this.getPro();
        this.drawer = false;
      },
      settle:function(){
        var that = this;
        var b_id = that.$route.query.id;
        var pro_id = '';
        var arr = JSON.parse(localStorage.getItem('ucart'+b_id));
        if(arr != null){ 
          for(var i = 0; i < arr.length; i++){
            pro_id += (pro_id == '' ? '' : ',') + arr[i].id;
          }
        }else{
          return false;
        }
        var price = that.price;
        if(that.setUserSvip != null){
          price = that.setUserSvip.type == 0 ? 0 : that.price; 
        }
        var number = this.$route.query.number;
        number = number == undefined ? 0 : number;
        that.axios({
          method:'post',
          url:that.$host+'home/product/saveOrder',
          params:{
            mall_id:b_id,
            user_id:that.userData.id,
            content:JSON.stringify(arr),
            num:that.total,
            price:(that.value == 2 ? (price + that.detail.take_price*1): price),
            pro_id:pro_id,
            type:that.value,
            tablenum:number
          }
        }).then(function(response){
          var res = response.data;
          if(res.status == 200){
            localStorage.removeItem('ucart'+b_id)
            that.$router.push({
              path:'payment',
              query:{
                id:res.data
              }
            })
          }
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      yqmKai:function(){
        this.dialogFormVisible = true;
      },
      svip:function(){
        var that = this;
        var b_id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/svip',
          params:{
            mall_id:b_id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setSvip = res;
          if(res.length > 0){
            that.vipPrice = res[0].rate;
            that.vip_id = res[0].id;
            that.classes = res[0].type;
          }
          
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      userSvip:function(){
        var that = this;
        var b_id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/isSvip',
          params:{
            mall_id:b_id,
            user_id:that.userData.id,
          }
        }).then(function(response){
          var res = response.data.data;
          that.setUserSvip = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      openSvip:function(){
        var that = this;
        var b_id = this.$route.query.id;
        if(that.form.name == ''){
          that.$alert('请输入邀请码', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/product/openSvip',
          params:{
            mall_id:b_id,
            user_id:that.userData.id,
            code:that.form.name
          }
        }).then(function(response){
          var res = response.data;
          if(res.status == 200){
            that.dialogFormVisible = false;
            that.userSvip();
          }else{
            that.$alert(res.message, '提示', {
              confirmButtonText: '确定'
            });
          }
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      paySvip:function(){
        var that = this;
        var b_id = this.$route.query.id;
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/product/paySvip',
          params:{
            mall_id:b_id,
            user_id:that.userData.id,
            classes:that.classes,
            vip_id:that.vip_id,
            price:that.vipPrice
          }
        }).then(function(response){
          var res = response.data;
          if(res.status == 200){
            that.callpay(res.data);
          }else{
            that.$alert('支付失败，请重新确认信息后支付！', '提示', {
              confirmButtonText: '确定'
            });
          }
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      jsApiCall:function(msg){

        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wxa89a20966e69c2a5',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    window.location.href="http://user.4008005216.com/main/viporder";
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },
      chooseVip:function(index,type,id,rate){
        this.xzSvip = index;
        this.classes = type;
        this.vip_id = id;
        this.vipPrice = rate;
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-dialog{
    width:80%
  }
  .detailApp{
    max-width:640px;
    background:#fff;
    margin:0 auto;
  }

  .detailApp .chant{
    width:100%;
    background:#fff;
    padding-bottom:10px
  }
  .detailApp .chant:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .detailApp .chant .bussy{
    float:left;
    width:70%;
    margin:15px 8px 0 15px;
    min-height:55px;
    position:relative;
  }
  .detailApp .chant .bussy h2{
    font-size:16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color:#000;
    letter-spacing:1px;
  }

  .detailApp .chant .bussy .star{
    font-size:14px;
    color:rgb(255,102,0);
    vertical-align: top;
    font-weight:600;
    position:absolute;
    bottom:0
  }
  .detailApp .chant .bussy .star img{
    width:12px;
    margin-right:3px;
  }
  .detailApp .chant .bussy .star span{
    color:#3C485C;
    font-weight:500;
    font-size:13px;
    padding-left:8px
  }
  .detailApp .chant .bussy .star font{
    font-weight:500;
    font-size:13px;
    color:#3C485C;
    padding-left:8px
  }
  .detailApp .chant .logo{
    width:20%;
    margin-top:10px;
    border-radius: 5px;
    float:left;
  }
  .detailApp .coupon{
  }
  .detailApp .coupon span{
    background:#FF1E00;
    border-radius: 3px;
    color:#fff;
    font-size:12px;
    margin-left:15px;
    float:left;
    height:25px;
    line-height:25px;
    padding-right:10px
  }
  .detailApp .coupon span.last{
    margin-left:2px;
    line-height:27px;
    padding-left:10px
  }
  .detailApp .coupon span.rebate{
    padding-left:10px;
    background:#eadd00
  }
  .detailApp .coupon:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .detailApp .coupon span i{
    font-style: normal;
    font-size:15px;
    font-weigth:bold;
    padding:0 4px;
    position:relative;
    top:1px
  }
  .detailApp .coupon span font{
    background:rgba(255,255,255,0.7);
    color:#FF1E00;
    border-radius: 0 0 15px 0;
    padding:0px 10px;
    float:left;
    height:25px;
    margin-right:8px
  }

  .detailApp .tab{
    background:#fff;
    height:45px;
    border-top:solid 1px #f1f1f1;
    border-bottom:solid 1px #f5f5f5;
    position:relative;
  }
  .detailApp .tab a{
    float:left;
    height:45px;
    line-height:45px;
    width:14%;
    text-align:center;
    font-size:15px;
    color:#666
  }
  .detailApp .tab a.curt{
    color:#E60000;
    position:relative;
    font-weight:bold
  }
  .detailApp .tab a.curt:after{
    position:absolute;
    bottom:8px;
    width:15px;
    content:'';
    height:2px;
    background:#FF1E00;
    left:50%;
    transform: translateX(-50%);
    border-radius: 3px;
  }
  .detailApp .goods{
    overflow-y: scroll;
    width:100%;
    position: relative;
  }
  .detailApp .goods ul{
    width:22%;
    background:#f5f5f5;
    position: absolute;
    left:0;
    top:0;
    height:100%;
    overflow-y: scroll;
  }
  .detailApp .goods ul li{
    font-size:13px;
    text-align:center;
    padding:15px 10px;
    color:#555;
    border-bottom:1px solid #fff
  }
  .detailApp .goods ul li.curt{
    color:#E60000
  }
  .detailApp .goods ul li:last-child{
    border-bottom:none
  }

  .detailApp .goods .proList{
    width:76%;
    position: absolute;
    left:24%;
    top:0%;
    height:100%;
    overflow-y: scroll;
    padding-top:10px
  }
  .detailApp .goods .proList dd{
    margin-bottom:15px;
  }
  .detailApp .goods .proList dd:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .detailApp .goods .proList .fmt{
    float:left;
    width:35%;
    border-radius: 6px;
  }
  .detailApp .goods .proList .right{
    float:left;
    width:63%;
    margin-left:2%;
    position: relative;
  }
  .detailApp .goods .proList .right h2{
    font-size:15px;
    color:#000;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    letter-spacing:1px;
  }

  .detailApp .goods .proList .right .sales{
    font-size:14px;
    color:#999;
    padding:8px 0
  }
  .detailApp .goods .proList .right .price{
    font-weight:bold;
    color:#E60000;
    font-size:15px
  }
  .detailApp .goods .proList .right .price font{
    color:#999;
    font-weight:normal;
    font-size:12px;
    text-decoration: line-through;
    padding-left:8px
  }
  .detailApp .goods .proList .right .cart{
    position: absolute;
    height:24px;
    right:10px;
    bottom:18px;
    color:#000;
    text-align:center;
    line-height:25px;
  }
  .detailApp .goods .proList .right .cart span{
    display:block;
    width:22px;
    height:22px;
    line-height:22px;
    background:#E60000;
    font-size:18px;
    position: relative;
    border-radius: 22px;
    color:#fff
  }
  .detailApp .goods .proList .right .cart font{
    font-size:10px;
    position: absolute;
    top:-3px;
    right:-3px;
    width:12px;
    height:12px;
    border-radius: 12px;
    background:#F2995F;
    color:#fff;
    line-height:12px;
  }

  .detailApp .goods .footPro{
    position: fixed;
    width:100%;
    left:0%;
    bottom:0px;
    background:#fff;
    padding:8px 0;
    border-top:solid 1px #D6DBE3
  }
  .detailApp .goods .footPro .left{
    float:left;
    margin-left:2%;
    margin-top:2px
  }
  .detailApp .goods .footPro .left a{
    float:left;
    font-size:12px;
    width:50px;
    text-align:center;
    color:#666;
    position: relative;
  }
  .detailApp .goods .footPro .left a font{
    position: absolute;
    top:0;
    right:10px;
    width:12px;
    height:12px;
    background:#E60000;
    border-radius: 50%;
    color:#fff;
    font-size:10px;
  }
  .detailApp .goods .footPro .left a:last-child{
    margin-left:5px
  }
  .detailApp .goods .footPro .left a em{
    display:block;
    font-size:20px;
    margin:0 auto;
    color:#666
  }
  .detailApp .goods .footPro .right{
    float:right;
    background:#E60000;
    height:40px;
    border-radius: 50px;
    width:180px;
    margin-right:4%
  }
  .detailApp .goods .footPro .right span{
    display:block;
    text-align:center;
    font-size:17px;
    font-weight:bold;
    color:#fff;
    padding-top:3px
  }
  .detailApp .goods .footPro .right span em{
    font-size:12px;
    font-style:normal;
    font-weight:normal
  }
  .detailApp .goods .footPro .right font{
    display:block;
    text-align:center;
    font-size:10px;
    color:rgba(255,255,255,0.8)
  }
  .detailApp .goods .footPro .price{
    float:left;
    width:68%;
    height:45px;
    border-radius: 50px 0 0 50px;
  }
  .detailApp .goods .footPro .price p{
    color:#fff;
    font-size:12px;
    margin-left:8%
  }
  .detailApp .goods .footPro .price p:first-child{
    font-weight:bold;
    font-size:18px;
    color:#fff;
    padding-top:1px
  }

  .detailApp .goods .footPro .settle{
    float:right;
    width:32%;
    height:45px;
    background:rgb(255,209,97);
    border-radius: 0 50px 50px 0;
    text-align:center;
    line-height:45px;
    font-weight:bold;
    font-size:15px;
  }
  .detailApp .comment img{
    display:block;
    width:100%
  }

  .detailApp .chants{
    width:100%;
    overflow-y: scroll;
    background:#f5f5f5
  }
  .detailApp .chants ul{
    background:#fff;
  }
  .detailApp .chants ul li{
    padding:15px 0;
    width:92%;
    margin:0 auto;
    border-bottom:solid 1px #f5f5f5
  }
  .detailApp .chants ul li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .detailApp .chants ul li span{
    float:left;
    width:80%;
    font-size:15px;
    letter-spacing:1px;
  }
  .detailApp .chants ul li a{
    border-left:solid 1px #ebebeb;
    font-size:15px;
    color:#000;
    text-align:center;
    text-decoration: none
  }
  .detailApp .chants ul li .sjImg{
    float:left;
    width:31%;
    margin-right:2%;
    margin-bottom:2%;
    border-radius: 6px;
  }

  .detailApp .logistics{
    float:right;
    height:45px;
    padding-right:4%;
  }
  .detailApp .logistics p{
    float:left;
    height:45px;
    line-height:45px;
    font-size:17px;
    color:#7787A2;
    margin-left:20px
  }
  .detailApp .logistics p.on{
    color:#E60000;
  }
  .detailApp .logistics p i{
    font-size:21px;
    margin-right:2px;
    float:left;
    margin-top:12px;
  }

  .el-switch__label--left{
    position: relative;
    left: 0px;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__label--right{
    position: relative;
    left: 38px;
    top:4px;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__label.is-active{
    z-index: 1111;
    color: #fff;
  }

  .el-switch__label--left{
    position: relative;
    left: 98px;
    color: #fff;
    top:4px;
    z-index: -1111;
  }
  .el-switch__label--right{
    position: relative;
    right: 98px;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__label--right.is-active{
    z-index: 1111;
    color: #fff !important;
  }
  .el-switch__label--left.is-active{
    z-index: 1111;
    color: #fff !important;
  }
  .el-switch__core{
    height:30px;
    border-radius: 30px
  }
  .el-switch__core:after{
    top:6px
  }

  .el-switch{
    float:right;
    display:inline;
    top:8px;
    height:30px;
    position:absolute;
    right:15px
  }
  .el-switch__label{
    float:left;
  }


  .svipDetail ul{
    display: flex;
    flex-wrap: wrap;
    width: 92%;
    justify-content: space-between;
    margin:0 auto;
  }
  .svipDetail ul li{
    width:31%;
    margin-bottom:10px
  }
  .svipDetail ul li .title{
    width: 100%;
    background: #f4f4f4;
    font-size: 15px;
    color: #33290c;
    text-align: center;
    height: 35px;
    line-height: 35px;
    border-radius: 5px 5px 0 0;
  }
  .svipDetail ul li .desc{
    border: 1px solid #e9e9e9;
    border-top:0 ;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    height: 70px;
    padding-bottom: 15px;
    border-radius:  0 0 5px 5px;
  }
  .svipDetail ul li .desc .yh{
    display: inline-block;
    font-size: 13px;
    color: #FFFFFF;
    background: #f4635c;
    padding: 0 5px;
    border-radius: 5px;
    margin-bottom:5px
  }
  .svipDetail ul li .desc .money{
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: baseline;
  }
  .svipDetail ul li .desc .money i{
    font-size: 12px;
  }
  .svipDetail ul li .desc .money span{
    font-size: 16px;
    font-weight: bold;
  }
  .svipDetail ul li .desc .old{
    font-size: 12px;
    color: #999;
  }
  .card-list .list p.tip{
    font-size: 16px;
    color: #999;
    padding-bottom: 15px;
    text-indent: 2em;
  }
  .svipDetail ul li.active .title{
    background: #ffec86;
    font-weight: bold;
    color: #33290c;
  }
  .svipDetail ul li.active .desc{
    background: #fefbec;
    border-color: #ffde86;
  }
  ul .pick {
    content: ' ';
    width: 31.5%;
    overflow: hidden;
  }
  .kaitong {
    width: 84%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-size: 15px;
    background: #FF751A;
    bottom: 20px;
    left: 8%;
    border-radius: 45px;
    border:none;
    margin:0 auto;
    display:block;
  }

  .vipUser{
    width:88%;
    margin:0 auto 20px auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    background: #FFFFFF;
    padding:15px 2%;
    border-radius: 8px;
    position:relative;
  }
  .vipUser .avatar{
    width:70px;
    border-radius: 50%;
    float:left;
  }
  .vipUser:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .vipUser p{
    float:left;
    width:75%;
    margin-left:10px;
    margin-top:5px
  }
  .vipUser p span{
    display:block;
    font-size:16px;
    font-weight:550;
  }
  .vipUser p font{
    font-size:12px;
    color:#666;
    display:block;
    padding-top:5px
  }
  .vipUser p img{
    width:18px;
    position:relative;
    left:5px;
    top:3px
  }
  .vipUser a{
    position:absolute;
    right:0;
    top:0;
    background:#FF751A;
    font-size:13px;
    color:#fff;
    padding:6px 10px;
    border-radius: 0 8px 0 8px;
  }
  .svipDetail h2{
    width:92%;
    margin:0 auto;
    font-size:15px;
    font-weight:550;
    padding-bottom:15px
  }
  .svipDetail h2 .gmjl{
    float:right;
    font-size:14px;
    color:#666
  }
  .svipDetail h2 .gmjl img{
    float:right;
    width:6px;
    margin:4px 0 0 5px
  }

  .detailApp .cartHead{
    height:50px;
    border-bottom:solid 1px #EBEDF1
  }
  .detailApp .cartHead .cleft{
    float:left;
    line-height:50px;
    font-size:14px;
    color:#333;
    margin-left:4%
  }
  .detailApp .cartHead .cright{
    float:right;
    line-height:50px;
    margin-right:4%;
    font-size:14px;
    color:#666
  }
</style>